import React, { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./login.scss";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Swal from "sweetalert2";
import { loginApi } from "../../Api";

function Login() {
  const navigate = useNavigate();
  const [userObj, setUserObj] = useState({ username: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  useEffect(()=>{
    localStorage.clear();
  },[])
  // Api starts here
  const submit = async () => {
      let formData = { ...userObj };
      console.log("formData",formData);
      if (!formData.username) {
        Swal.fire({
          text: "Please enter your email address.",
          icon: "warning",
          showConfirmButton: false,
          heightAuto: false,
          timer: 1500,
        });
      }
      else if (!formData.password) {
        Swal.fire({
          text: "Please enter password.",
          icon: "warning",
          showConfirmButton: false,
          heightAuto: false,
          timer: 1500,
        });
      }
      else {
        Swal.fire({
          html: `<img src=${require("../../assets/loader.gif")} style="width: 50px" alt="loader">`,
          showConfirmButton: false,
          heightAuto: false,
          customClass: { popup: "loader-swal" },
          allowOutsideClick: false,
        });
        let loginData = await loginApi(formData);
        Swal.close();
        if (loginData.status === "S") {
          localStorage.setItem("loggedIn", true);
          localStorage.setItem("userData", JSON.stringify(loginData.result_info));
          console.log(loginData);
          localStorage.setItem("token", JSON.stringify(loginData.token));
          localStorage.setItem("correl_id", loginData.correl_id);
          localStorage.setItem("role_id", loginData.role_id); // Store role_id
          localStorage.setItem("bank_code", loginData.result_info.bank_code); // Store bank_code
           if (
            loginData.is_first_time_login === "Y"
          ) {
            navigate("/change-password");
            return;
          } else if(loginData.is_first_time_login === "N"){

            navigate("/import");
            return;
          }
          else {
            navigate("/import");
            return;
          }
        } else if (loginData.status === "E") {
          Swal.fire({
            text: loginData.message,
            showConfirmButton: false,
            icon: "warning",
            timer: 3000,
          });
          return;
        } else if (loginData.status === "F") {
          Swal.fire({
            text:
              loginData.status === "E"
                ? loginData.errorDescription
                  ? loginData.errorDescription
                  : "Something went wrong"
                : "Something went wrong",
            showConfirmButton: false,
            icon: "warning",
            timer: 3000,
          });
          return;
        }
      }
  }

  return (
    <div className="loginContainer login-page">
      <div className="row g-0 h-100 w-100">
        <div className="col-6">
          <div className="loginLeft d-none d-lg-flex">
            <h2 className="headingText">
              <strong>Welcome to <span className="color-text">PRISM</span> </strong>
            </h2>
            <img
              src={require("../../assets/image.png")}
              alt="UpwardiqPrism"
              className="vec-image"
            />
            <h5 className="mt-3">
              Performance Review & Insights for Sanctions Model
            </h5>
          </div>
        </div>
        <div className="col-12 col-lg-6 h-100">
          <div className="loginRight h-100">
            <h5 className="loginText">Login to your Account</h5>
            <TextField
              id="emailInput"
              label="Email Address *"
              variant="outlined"
              className="mb-3 cust-white-input-field"
              autoComplete="off"
              value={userObj.username}
              onChange={(ev) => {
                const input = ev.target.value;
                // Regular expression to block specific patterns
                const disallowedPattern =
                  /<script.*?>.*?<\/script>|<.*?>|[<>/:?\]|"',;]/i;

                // Allow input only if it doesn't match the pattern
                if (!disallowedPattern.test(input)) {
                  setUserObj({ ...userObj, username: input });
                }
              }}
            />

            <TextField
              id="outlined-basic"
              label="Password *"
              variant="outlined"
              className="mb-1 cust-white-input-field"
              autoComplete="off"
              type={showPassword ? "text" : "password"}
              value={userObj.password}
              inputProps={{ minLength: 8, maxLength: 16 }}
              onChange={(ev) => {
                const input = ev.target.value;
                const allowedPattern = /^[a-zA-Z0-9.@_\-\s]*$/;
                // Allow input only if it matches the allowed pattern
                if (allowedPattern.test(input)) {
                  setUserObj({
                    ...userObj,
                    password: input,
                  });
                }
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      className="text-white"
                      aria-label="toggle password visibility"
                      onClick={() => {
                        setShowPassword(!showPassword);
                      }}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              onKeyDown={(ev) => {
                if (ev.key === "Enter") {
                  ev.preventDefault();
                  submit();
                }
              }}
            />
            <div className="mt-4">
              <button
                className="btn btn-white rounded-pill text-uppercase"
                onClick={submit}
              >
                Login
              </button>
            </div>
            <div className="text-center mt-2">
              <button
                className="btn btn-light-black"
                onClick={() => {
                  navigate("/forgot-password");
                }}
              >
                Forgot Password?
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
